var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlarmMotion = function SvgAlarmMotion(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4174",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect4790",
    width: 5.64,
    height: 10.443,
    x: 1.98,
    y: 1040.9,
    fill: "currentColor",
    rx: 1.651
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4813",
    fill: "currentColor",
    d: "M6 1031a2.375 2.375 0 0 0-2.375 2.375A2.375 2.375 0 0 0 6 1035.75a2.375 2.375 0 0 0 2.375-2.375A2.375 2.375 0 0 0 6 1031",
    transform: "matrix(1.2 0 0 1.2013 -2.4 -209.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4798",
    width: 9.6,
    height: 7.927,
    x: 0,
    y: 1036.2,
    fill: "currentColor",
    rx: 1.195,
    ry: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse4802",
    cx: 4.8,
    cy: 1037.4,
    fill: "currentColor",
    rx: 4.8,
    ry: 2.402
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4815",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M8.328 1028.8c1.713 1.787 1.714 3.892 1.084 5.18.637.478 2.24 1.33 2.24 3.296l.01 5.582c0 2.071-1.93 3.008-1.93 3.008l.013 4.585c0 1.022-.783 1.604-.783 1.604"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4817",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M11.231 1028.7c.206.263 1.238 2.065.881 4.298 0 0 1.931 1.67 1.931 3.98v6.062c0 2.404-1.95 4.073-1.95 4.073v3.228c0 1.279-.375 1.558-.375 1.558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4724-6",
    fill: "currentColor",
    d: "M17.334 1028.4c-.739 0-1.334.595-1.334 1.334v9.332c0 .739.595 1.334 1.334 1.334h5.332c.739 0 1.334-.595 1.334-1.334v-9.332c0-.739-.595-1.334-1.334-1.334z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path4853",
    cx: 20,
    cy: 1037.4,
    r: 1.5,
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlarmMotion);
export default ForwardRef;